import React from 'react';
import {
    Grid, Menu, Breadcrumb, Tab, Icon
} from 'semantic-ui-react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import ListDenuncia from './ListDenuncia'
import ListOuvidoria from './ListOuvidoria';


function Ouvidoria(props) {

    const { userid } = props;


    let panes = [

    ];
    if (userid == 2 || userid == 3 || userid == 79 || userid == 86 | userid == 33) {
        panes.push(
            {
                menuItem: <Menu.Item key='TABpendente'><Icon name='balance scale' />Denúncia Anônima</Menu.Item>,
                render: () => <ListDenuncia />
            }
        )
    }
    panes.push(
        {
            menuItem: <Menu.Item key='TABpendente'><Icon name='bullhorn' />Ouvidoria Identificada</Menu.Item>,
            render: () => <ListOuvidoria />
        }
    )



    return (

        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}
>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Ouvidoria</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling>
                    <Grid.Column>
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            </div>

            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                    

                .ui.breadcrumb .active.section {
                    background-color: #1884af !important;
                    color: #fff !important;
                }
            `}</style>

        </div>
    );
}

const mapStateToProps = state => (
    {
        userid: state.LoginReducer.userid,
    }
);

export default withRouter(connect(mapStateToProps, {
}
)(Ouvidoria));